import * as yup from 'yup'
import { ApplicationFormAnswers } from '../components/ApplicationForm/ApplicationFormContext'
import BaseValidator from './BaseValidator'
import { mobileNumberRegex } from '../constants'

export const checkIsValidPhoneNumber = (phoneNumber?: string | string[]) => {
  if (!phoneNumber) return false
  const phoneNumberToCheck = Array.isArray(phoneNumber) ? phoneNumber[0] : phoneNumber
  return mobileNumberRegex.test(phoneNumberToCheck)
}


const MobileNumberValidator = (): BaseValidator => {
  const schema = yup.object().shape({
    contactNumber: yup.string().matches(mobileNumberRegex, {
      message: 'Please enter a valid mobile number',
      excludeEmptyString: true
    })
      .typeError('Please enter a valid mobile number')
      .required('Please enter your mobile number')
  })

  return {
    getValidator: () => schema as yup.BaseSchema,
    validateState: (state: ApplicationFormAnswers) => schema.isValidSync({
      contactNumber: state.contactNumber
    })
  }
}

export default MobileNumberValidator
